<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
      <progress-q></progress-q>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <v-card v-if="!shopLoad" class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke">
            <v-toolbar-title>{{
              getString("Manutenzione negozio")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12>
              <v-card-text>
                <v-layout style="vertical-align: middle;">
                  <h3>
                    {{
                      getString(
                        "Elimina tutte le prenotazioni dal calendario, dalle statistiche fino alla giornata di ieri."
                      )
                    }}
                  </h3>
                  <v-btn
                    class="q-orange-bk q-text-whitesmoke"
                    dark
                    small
                    @click="
                      () => {
                        alertDialog = true;
                      }
                    "
                  >
                    <v-icon>delete</v-icon>
                    Cancella
                  </v-btn>
                </v-layout>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="alertDialog" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">{{getString('Conferma cancellazione')}}</span>
            </v-card-title>
            <v-card-text>
                    <p v-html="getString(`<b>Attenzione</b>, stai per cancellare tutte le prenotazioni effettuate fino a ieri.L'operazione è irreversibile. Sei sicuro di procedere?`)">
                    </p>
            </v-card-text>
            <v-card-actions>
                <v-btn class="q-orange" flat @click="alertDialog = false">{{getString('Chiudi')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="q-orange" flat @click="deleteOldReservation">{{getString('Procedi')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import moment from 'moment';
var ut = new Utils();
export default {
  name: "ShopMaintenance",
  props: ["shopID", "tab"],
  components: {
    ProgressQ,
  },
  mounted: function () {
   
  },
  computed: {
    shopLoad: function() {
      return false
    }
  },
  data: () => {
    return {
      alertDialog: false
    };
  },
  watch: {},
  methods: {
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    deleteOldReservation: function () {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() + "/admin/shops/" + self.shopID + "/oldReservation",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            var numDeleted = response.data.data;
            self.$emit(
              "siteAlertSuccess",
              self.getString("Cancellate " + numDeleted + " prenotazioni.")
            );
            self.alertDialog = false
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
  },
};
</script>

<style scoped>
.avatar-img {
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  transition: max-height 0.3s ease-in-out;
}

.avatar-img:hover {
  max-height: 600px;
}

.save-alert {
  animation-name: saveAlertAnimation1 !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

@keyframes saveAlertAnimation1 {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }

  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopMaintenance.vue